import React, { Fragment, useEffect, useState } from 'react';
import {
  Row,
  Col,
  Card,
  Button,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  InputGroup, InputGroupText
} from 'reactstrap';
import {
  authHeader,
  authfileHeader
} from '../../utils/functions/CoreFunctions';
import {
  USER_DETAILS_URL,
  FILE_UPLOAD_URL,
  AGENCY_USER_UPDATE_URL
} from '../../utils/APIEndpoints';
import API from '../../redux/actions/API';
import {
  getAlertToast,
  getCurrentUserId,
  SingleStringFirstLetterCaps
} from '../../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ONLY_STRING, TEN_DIGIT_PHONE_NUMBER_REGEX } from '../../utils/constants/ValidationRegexs';
import defaultAvatar from '../../assets/images/defaultImages/defaultAvatar.png';
import { LOCALSTORAGE_AUTH_USER } from '../../utils/constants/LocalStorage';
import CustomLoader from '../common/CustomLoader';

//Validation Schema
const validationSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .required('First name is required').matches(ONLY_STRING, 'Only letters allowed'),
  lastName: Yup.string()
    .trim()
    .required('Last name is required').matches(ONLY_STRING, 'Only letters allowed'),
  email: Yup.string()
    .trim()
    .required('Email is required')
    .email('Enter valid email'),
  phoneNumber: Yup.string()
    .trim()
    .required('Phone number is required')
    .matches(TEN_DIGIT_PHONE_NUMBER_REGEX, 'Enter valid phone number'),
  address: Yup.string()
    .trim()
    .required('Address is required')
  // role : Yup.string().trim().required('Role is required'),
});

const Profile = props => {
  const [adminData, setAdminData] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setButtonLoading] = useState(false);
  const [image, setImage] = useState();

  const handleUpload = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    const options = {
      method: 'POST',
      url: FILE_UPLOAD_URL,
      headers: authfileHeader(),
      data: formData
    };
    try {
      Swal.fire(getAlertToast('success', 'Please wait...'));
      var apiResponse = await API(options);
      const { status, filepath } = apiResponse.data;
      if (status === 'Success') {
        setImage(filepath);
      }
    } catch (error) {
      if (error.response) {
        Swal.fire(getAlertToast('error', 'File upload failed, please try again!' ));
        }
    }
  };

  //On Submit
  const saveFormValues = async values => {
    values.createdBy = getCurrentUserId();
    values.profileImage = image;
    const options = {
      method: 'PUT',
      url: AGENCY_USER_UPDATE_URL,
      headers: authHeader(),
      data: values
    };
    try {
      setButtonLoading(true);
      let response = await API(options);
      const { status, message } = response.data;
      if (status === 'Error') {
        Swal.fire(getAlertToast('error', message));
      } else {
        Swal.fire(getAlertToast('success', 'User updated successfully'));
        let loggedUserData = {
          userId: adminData.userId,
          role: adminData.role,
          agencyId: adminData.agencyId,
          firstName: values.firstName,
          lastName: values.lastName,
          profileImage: values.profileImage
        };
        localStorage.setItem(
          LOCALSTORAGE_AUTH_USER,
          JSON.stringify(loggedUserData)
        );
        getAdminData();
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setButtonLoading(false);
    }
  };

  //Formik
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    setFieldTouched,
    setFieldValue
  } = useFormik({
    initialValues: {
      ...adminData
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: values => saveFormValues(values)
  });

  //Get Dashboard Data
  const getAdminData = async () => {
    setLoading(true);
    const options = {
      method: 'GET',
      url: USER_DETAILS_URL,
      headers: authHeader(),
      params: { userId: getCurrentUserId() }
    };
    try {
      const response = await API(options);
      const { status } = response.data;
      if (status === 'Success') {
        setAdminData(response.data);
        setImage(response.data.profileImage);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Did Mount
  useEffect(() => {
    getAdminData();
  }, []);

  return (
    <Fragment>
      <Row>
        <Col md='5' xs='4'>
          <Card body>
            <center>{loading && <CustomLoader loading={loading} />}</center>

            <div className='manageUsertag'>
              <img
              alt='user profile'
                className='manageUserImg'
                src={adminData.profileImage || defaultAvatar}
              />
              <h4>
                {adminData.firstName} {adminData.lastName}
              </h4>
              <p>{adminData.role}</p>
            </div>

            <div className='kt-widget__content'>
              <div className='kt-widget__info'>
                <span className='kt-widget__label'>Email:</span>
                <span href='#' className='kt-widget__data'>
                  {adminData.email}
                </span>
              </div>
              <div className='kt-widget__info'>
                <span className='kt-widget__label'>Phone Number:</span>
                <span href='#' className='kt-widget__data'>
                  (+1) {adminData.phoneNumber}
                </span>
              </div>
              <div className='kt-widget__info'>
                <span className='kt-widget__label'>Address:</span>
                <span className='kt-widget__data'>{adminData.address}</span>
              </div>
            </div>
          </Card>
        </Col>
        <Col md='7' xs='8'>
          <Card className='manageUpdate'>
            <CardHeader>
              Personal Information <span>Update your personal information</span>{' '}
            </CardHeader>
            <CardBody>
              <center>{loading && <CustomLoader loading={loading} />}</center>

              <Form onSubmit={handleSubmit}>
                <h6 className='mb-4 cardholder-info'>Basic Info:</h6>

                <FormGroup row className="profile-form">
                  <Label for='exampleEmail' sm={3}>
                    Profile
                  </Label>
                  <Col sm={9}>
                    <div className="profile-upload">
  <img
    className="uploadImg"
    src={image || defaultAvatar}
    alt="Profile"
  />

  <label className="btn-bs-file admin-pro-camera">
    <i className="fas fa-camera"></i>
    <Input type="file" onChange={handleUpload} />
  </label>
</div>
                  </Col>
                </FormGroup>

                <FormGroup row >
                  <Label for='firstName' sm={3}>
                    First Name
                  </Label>
                  <Col sm={9}>
                    <Input
                      type='text'
                      name='firstName'
                      placeholder='First Name'
                      invalid={errors.firstName ? true : false}
                      onChange={({ target: { value } }) => {
                        setFieldTouched('firstName', true);
                        setFieldValue(
                          'firstName',
                          SingleStringFirstLetterCaps(value)
                        );
                      }}
                      value={values.firstName}
                    />
                    <FormFeedback>
                      {errors.firstName ? errors.firstName : ''}
                    </FormFeedback>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for='lastName' sm={3}>
                    Last Name
                  </Label>
                  <Col sm={9}>
                    <Input
                      type='text'
                      name='lastName'
                      id='lastName'
                      placeholder='Last Name'
                      invalid={errors.lastName ? true : false}
                      onChange={({ target: { value } }) => {
                        setFieldTouched('lastName', true);
                        setFieldValue(
                          'lastName',
                          SingleStringFirstLetterCaps(value)
                        );
                      }}
                      value={values.lastName}
                    />
                    <FormFeedback>
                      {errors.lastName ? errors.lastName : ''}
                    </FormFeedback>
                  </Col>
                </FormGroup>
                {/* <FormGroup row>
      <Label for="role" sm={3}>Role</Label>
        <Col sm={9}>
          <Input type="select" name="role" id="role" placeholder="Role"
          invalid={errors.role ? true : false} onChange={handleChange} value={values.role}>
              <option value=''>------Select Role-------</option>
              <option value='Merchant Admin'>Merchant Admin</option>
              <option value='Merchant Manager'>Merchant Manager</option>
          </Input>
          <FormFeedback>{errors.role ? errors.role : ''}</FormFeedback>
          </Col>
        </FormGroup> */}

                <h6 className='mb-4 cardholder-info'>Contact Info:</h6>

                <FormGroup row>
                  <Label for='phone' sm={3}>
                    Contact Phone
                  </Label>
                  <Col sm={9}>
                    <InputGroup>
                      
                        <InputGroupText>+1</InputGroupText>
                      
                      <Input
                        type='text'
                        name='phoneNumber'
                        id='phoneNumber'
                        placeholder='Phone Number'
                        invalid={errors.phoneNumber ? true : false}
                        onChange={handleChange}
                        value={values.phoneNumber}
                      />
                      <FormFeedback>
                        {errors.phoneNumber ? errors.phoneNumber : ''}
                      </FormFeedback>
                    </InputGroup>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for='email' sm={3}>
                    Contact Email
                  </Label>
                  <Col sm={9}>
                    <Input
                      type='email'
                      name='email'
                      id='email'
                      placeholder='Email'
                      invalid={errors.email ? true : false}
                      onChange={handleChange}
                      value={values.email}
                      disabled
                    />
                    <FormFeedback>
                      {errors.email ? errors.email : ''}
                    </FormFeedback>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Label for='address' sm={3}>
                    Address
                  </Label>
                  <Col sm={9}>
                    <Input
                      type='textarea'
                      name='address'
                      id='address'
                      placeholder='Address'
                      invalid={errors.address ? true : false}
                      onChange={handleChange}
                      value={values.address}
                    />
                    <FormFeedback>
                      {errors.address ? errors.address : ''}
                    </FormFeedback>
                  </Col>
                </FormGroup>

                <FormGroup check row>
                  <Col sm={{ size: 9, offset: 3 }}>
                    <Button type='submit' color='primary'>
                      {btnLoading && <CustomLoader loading={btnLoading} />}{' '}
                      Update
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Profile;

